import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { StyledTitle } from '@selfserve/react-ui';
import { StyledInfoText } from '../feature/forgot-password';
import { ForgotPasswordForm, Props } from './forgot-password-form';

const StyledForgotPasswordContainer = styled.div`
  max-width: 448px;
  width: 100%;
`;

const StyledForgotPasswordTitle = styled(StyledTitle)`
  display: block;
  margin-bottom: 32px;
  text-align: center;
`;

export const ForgotPasswordContainer = (props: Props) => {
  const { t } = useTranslation();
  return (
    <StyledForgotPasswordContainer>
      <StyledForgotPasswordTitle>
        {t('common.reset-password')}
      </StyledForgotPasswordTitle>
      <StyledInfoText>
        {t('common.forgot-password-instructions')}
      </StyledInfoText>
      <ForgotPasswordForm {...props} />
    </StyledForgotPasswordContainer>
  );
};
